import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/Button";
import { Modal } from "@components/Modal/Modal";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import type { IConfirmationModalProps } from "./types";

export const ConfirmationModal: React.FC<
  IConfirmationModalProps & IUseModalProps
> = ({
  title,
  subtitle,
  confirmButtonLabel,
  cancelButtonLabel,
  onConfirm,
  children,
  ...modalProps
}) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const { t } = useTranslation();
  const modal = useModal(modalProps);

  return (
    <Modal
      modal={modal}
      title={title}
      subtitle={subtitle}
      actionButtons={
        <>
          <Button className="w-full" variant="secondary" onClick={modal.close}>
            {cancelButtonLabel ?? t("confirmationModal.actions.cancel")}
          </Button>
          <Button
            className="w-full"
            isLoading={isConfirming}
            onClick={async () => {
              setIsConfirming(true);
              await onConfirm?.().finally(modal.close);
            }}
          >
            {confirmButtonLabel ?? t("confirmationModal.actions.confirm")}
          </Button>
        </>
      }
    >
      {children}
    </Modal>
  );
};
